
export interface User {
    uid: string,
    handle: string,
    isAdmin: boolean,
    isEnabled: boolean,
    subLevel: number,
    subExpire: any,
    subLicense: string,
    factions: string[],
    routeSkills?: UserRouteSkills,
    hyperlaneDefaultPresetId?: string|null,
    privs: PermissionList,
    moduleTypes: string[]
}

export interface UserRouteSkills {
    hyper: number,
    skill: number,
}
export const permissionKeys = ['manageTavernNetwork', 'manageLicenses', 'managePermissions'] as const;

export type PermissionKey = typeof permissionKeys[number];

type PermissionList = {
    [key in PermissionKey]: boolean
}

export interface Faction {
    id: string,
    leader: { id: string, name: string } | null,
    second: { id: string, name: string } | null,
    parent: string|null,
    permissions?: FactionPermission,
    modules: string[],
    name: string
}


export type FactionPermission = PermissionList & {
    user: string;
    userName: string;
};

export interface UserFaction {
    [key: string]: Faction
}

export interface SimpleUser {
    id: string;
    name: string;
}

export interface License {
    id: string;
    buyer: SimpleUser;
    type: 'self' | 'gift' | 'voucher' | 'group';
    targetUser?: SimpleUser;
    created: number;
    payDate: number;
    status: string;
    duration: number;
    activeDate?: number;
    expireDate?: number;
    actualBuyer?: SimpleUser;
    voucherExpire?: number;
    redeemedBy?: SimpleUser;
    redeemedDate?: number;
}

export interface LicenseTransaction {
    id: string,
    buyer: string,
    buyerType: number,
    licenses: License[],
    payDate: number|null,
    payExpire: number,
    price: number,
    link?: string
}


interface ParsedLocationContainer {
    name: string,
    uid: string,
    type: string,
}
interface ParseLocationCoordinates {
    x: number,
    y: number,
}

export interface ParsedLocation {
    container?: ParsedLocationContainer,
    sector?: ParsedLocationContainer,
    system?: ParsedLocationContainer,
    planet?: ParsedLocationContainer,
    city?: ParsedLocationContainer,
    coordinates: {
        galaxy: ParseLocationCoordinates,
        system: ParseLocationCoordinates,
        surface?: ParseLocationCoordinates,
        ground?: ParseLocationCoordinates
    }
}

interface Ware {
    name: string,
    type: string,
    quantity: number,
    price: number,
    currency: string,
    images: {
        small: string,
        large: string
    }
}


export interface Vendor {
    id: string,
    name: string,
    merchant: string,
    merchantImage: string,
    owner: string,
    ownerName: string,

    location: ParsedLocation,
    wares: Ware[]
}
